import { render, staticRenderFns } from "./ConfigureDocumentExpirationDates.vue?vue&type=template&id=5b3f2f07"
import script from "./ConfigureDocumentExpirationDates.vue?vue&type=script&lang=js"
export * from "./ConfigureDocumentExpirationDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports